const getRangeItemsIdByIndexes = (items, startIndex, endIndex) =>
  items.slice(startIndex, endIndex).map((item) => item.id);

export default getRangeItemsIdByIndexes;
